export class SearchDealersRequest {
  partnerCode: string; 
  partnerPassword: string;
  address: string; //On met le code postal ici pour avoir les 10 plus proches
  weight:number;
  weightUnit:string;
  dimensionUnit:string;
  width:number;
  height:number;
  length:number;
}
export class DealerResponse {
  dealerID: number; 
  dealerNo: number;
  dealerName: string;
  dealerAddress1: string;
  dealerAddress2: string;
  dealerCity: string;
  dealerProvince: string;
  dealerCountry: string;
  dealerPostal: string;
  dealerPhone: string;
  dealerHours: string;
  dealerOpen24s: string;
  dealerLanguage: string;
  dealerLatitude: string;
  dealerLongitude: string;
}
